import {
  newSlice,
  _fetchEntitiesService,
  _loadEvents,
  // _createEntityService,
  //  _updateEntityService,
  // _deleteEntityService,
} from "./common/sliceFunctions2";

var entitiesName = "payrollAssistants";

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code = "GET_PAYROLLS_ASSISTANTS";
  dataSlice.dataUrl.oid = dataSlice.orgId ? dataSlice.orgId : null;

  return _fetchEntitiesService(dataSlice, events);
}
